module.exports = __webpack_public_path__ + "img/liuliang_logo.5ccbe647.png";